// extracted by mini-css-extract-plugin
export default {"btn":"ButtonLit_btn__bgqtO"};